import { SystemPageType } from '../../enums/system-page-type/system-page-type.enum';

const VARIABLE_NAMES: Record<SystemPageType, string | undefined> = {
  [SystemPageType.REGISTRATION_NUMBERS]: undefined,
  [SystemPageType.ORDER_OVERVIEW]: undefined,
  [SystemPageType.ADDRESSES]: undefined,
  [SystemPageType.ORDER_DETAIL]: ':orderId',
  [SystemPageType.VAT_NUMBERS]: undefined,
  [SystemPageType.SHIPMENT]: ':shipmentId',
  [SystemPageType.CALL_OFF_ORDER_DETAIL]: ':orderId',
  [SystemPageType.INVOICES]: undefined,
  [SystemPageType.MY_PRODUCTS_AND_PRICES]: undefined,
  [SystemPageType.QUOTE_DETAIL]: ':quoteId',
  [SystemPageType.SHOPPING_CART]: undefined,
  [SystemPageType.CHECKOUT]: undefined,
  [SystemPageType.PORTAL_USERS]: undefined,
  [SystemPageType.COMPANY_INFO]: undefined,
  [SystemPageType.PRODUCT_COMPARE]: undefined,
  [SystemPageType.LIMITED_PRODUCT_DETAIL]: ':ohmProductId'
};

export class SystemPageUtils {
  /**
   * Gets the variable name of the current page entry, if it is a system page
   *
   * @param type - The type of the system page
   *
   * @returns The variable name of the given system page type
   */
  static getSystemPageVariableName(type: SystemPageType): string | undefined {
    return VARIABLE_NAMES[type];
  }
}
